import { window } from "../window";

/**
 * Finds first parent element with matching property/value pair.
 */

export const getFirstParentWithMatchingStyle = (
  element: HTMLElement | null,
  property: string,
  value: string
): HTMLElement | undefined => {
  let isStillLooking = true;
  let workingElement: HTMLElement | null = element;

  while (workingElement && isStillLooking) {
    workingElement = workingElement.parentNode as HTMLElement | null;

    if ((workingElement as unknown) === window.document) {
      workingElement = null;
    }

    if (workingElement && isStillLooking) {
      const overflow = getComputedValue(workingElement, property);

      if (overflow === value) {
        isStillLooking = false;
      }
    }
  }

  return workingElement ?? undefined;
};

function getComputedValue(element: HTMLElement, property: string): string {
  return window.getComputedStyle(element).getPropertyValue(property);
}
